/**
     * Calculates the percentage change in a measure between a baseline and an updated value.
     * This function is used to calculate the total column value for percentage change measures
     * (e.g., ChangeInSalesRevenuePct, ChangeInProfitMarginPct, or ChangeInFCPct).
     *
     * @param {number} baselineMeasureId - The ID of the baseline measure.
     * @param {number} updatedMeasureId - The ID of the updated measure.
     * @param {any} columnData - The column data used to find the corresponding rows.
     *
     * @returns {number | undefined} The calculated percentage change if the baseline measure total is not zero, otherwise undefined.
   */
export const  calculatePercentageChangeInMeasure = (uiList:any, baslineMeasureId: number, updatedMeasureId: number, columnData: any, field: string): number | undefined => {
    const BaselineMeasureRow = uiList.find((row:any) => columnData && columnData.data && row.itemId == columnData.data.itemId && row.channelId == columnData.data.channelId && row.measureId == baslineMeasureId);
    const UpdatedMeasureRow = uiList.find((row:any) => columnData && columnData.data && row.itemId == columnData.data.itemId && row.channelId == columnData.data.channelId && row.measureId == updatedMeasureId);
    if (BaselineMeasureRow && BaselineMeasureRow[field] && UpdatedMeasureRow) {
      let BaselineMeasureTotal = BaselineMeasureRow[field] ? BaselineMeasureRow[field].toString().replace(/,/g, '') : 0 ;
      let UpdatedMeasureTotal = UpdatedMeasureRow[field]? UpdatedMeasureRow[field].toString().replace(/,/g, ''): 0;
      // checking if denominator is not zero than perform the calculation
      if (+BaselineMeasureTotal) {
        return (+UpdatedMeasureTotal - +BaselineMeasureTotal) / +BaselineMeasureTotal;
      }
    }
    return undefined;
  }